import http from '../util/request.js'

export const  messageList= (params) =>{
	return http({
		url:'/apistore/message/list',
		data:params,
		method:'get'
	})
}
export const  newNoticeList= (params) =>{
	return http({
		url:'/apistore/home/queryMsglist',
		data:params,
		method:'get'
	})
}
export const  getNoticeQty= (params) =>{
	return http({
		url:'/apistore/home/queryMsgqty',
		data:params,
		method:'get'
	})
}
export const  queryMsgdtl= (params) =>{
	return http({
		url:'/apistore/home/queryMsgdtl',
		data:params,
		method:'get'
	})
}
export const  queryMsgAlllist= (params) =>{
	return http({
		url:'/apistore/home/queryMsgAlllist',
		data:params,
		method:'get'
	})
}
export const  getStoreMessagedtl= (params) =>{
	return http({
		url:'/apistore/message/getStoreMessagedtl',
		data:params,
		method:'get'
	})
}
export const  quernewmsg= (params) =>{
	return http({
		url:'/apistore/message/quernewmsg',
		data:params,
		method:'get'
	})
}
export const  continueProductMessage= (params) =>{
	return http({
		url:'/apistore/message/continueProductMessage',
		data:params,
		method:'get'
	})
}